import store from '@/store'

const { auth } = store.state
export function superAdminGuard(to, from, next) {
  if (auth.user.user_role !== 'super_admin') {
    next({ name: 'home' });
  } else {
    next();
  }
}

export function adminTypeBGuard(to, from, next) {
  if (auth.user.user_role === 'admin_type_b') {
    next({ name: 'home' });
  } else {
    next();
  }
}

